import { Link } from 'react-router-dom';
import { AlertTriangle, RotateCcw, Home, ChevronDown } from 'lucide-react';

interface ErrorFallbackProps {
  error: Error | null;
}

export function ErrorFallback({ error }: ErrorFallbackProps) {
  const isDev = import.meta.env.DEV;

  return (
    <div className="min-h-screen bg-warm-dark flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* Ícone */}
        <div className="w-20 h-20 mx-auto mb-6 rounded-2xl bg-coral/10 flex items-center justify-center">
          <AlertTriangle className="w-10 h-10 text-coral" />
        </div>

        {/* Título */}
        <h1 className="font-display text-4xl md:text-5xl text-white mb-4 tracking-wide">
          Algo deu errado
        </h1>

        {/* Descrição */}
        <p className="font-body text-warm-200 text-base md:text-lg mb-8 leading-relaxed">
          Ocorreu um erro inesperado ao carregar esta página.
          <br className="hidden sm:block" />
          Tente recarregar ou volte para a página inicial.
        </p>

        {/* Botões */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center gap-2 bg-coral hover:bg-coral-dark text-white font-body font-semibold rounded-xl px-6 py-3 transition-all hover:-translate-y-0.5"
          >
            <RotateCcw className="w-4 h-4" />
            Recarregar página
          </button>
          <Link
            to="/"
            className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/15 text-white font-body font-semibold rounded-xl px-6 py-3 transition-all"
          >
            <Home className="w-4 h-4" />
            Voltar para home
          </Link>
        </div>

        {/* Stack trace (apenas em dev) */}
        {isDev && error && (
          <details className="text-left">
            <summary className="flex items-center gap-2 text-warm-400 font-body text-sm cursor-pointer hover:text-warm-300 transition-colors">
              <ChevronDown className="w-4 h-4" />
              Ver detalhes do erro (dev)
            </summary>
            <div className="mt-3 p-4 rounded-xl bg-black/30 overflow-auto">
              <p className="font-mono text-red-300 text-sm mb-2">{error.name}: {error.message}</p>
              <pre className="font-mono text-warm-500 text-xs whitespace-pre-wrap">
                {error.stack}
              </pre>
            </div>
          </details>
        )}
      </div>
    </div>
  );
}
